import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { IntelligentProposalType } from "../shared/types/renegotiation.type";

export class SetIntelligentProposal {
    static readonly type = '[IntelligentProposal] Set Intelligent Proposal';
    constructor(public payload: IntelligentProposalType) {}
}

export class SetIntelligentProposalFlow2 {
    static readonly type = '[IntelligentProposal] Set Intelligent Proposal Flow2';
    constructor(public payload: IntelligentProposalType[]) {}
}

export class SetNextRankPage {
    static readonly type = '[Intelligent Proposal] Set Next Rank Page';
    constructor(public payload: number | null) {}
}

export interface IntelligentProposalStateModel {
    nextRankPage?: number | null;
    intelligentProposal?: IntelligentProposalType;
    intelligentProposalFlow2?: IntelligentProposalType[];
}

export interface IntelligentProposalFlow2StateModel {
    intelligentProposalFlow2?: IntelligentProposalType[];
}

@State<IntelligentProposalStateModel>({
    name: 'intelligentProposalState',
})
@Injectable()
export class IntelligentProposalState {

    @Selector()
    static getIntelligentProposal(state: IntelligentProposalStateModel) {
        return state.intelligentProposal;
    }

    @Selector()
    static getIntelligentProposalFlow2(state: IntelligentProposalStateModel) {
        return state.intelligentProposalFlow2;
    }

    @Selector()
    static getNextRankPage(state: IntelligentProposalStateModel) {
        return state.nextRankPage;
    }

    @Action(SetIntelligentProposal)
    setIntelligentProposal(ctx: StateContext<IntelligentProposalStateModel>, action: SetIntelligentProposal) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            intelligentProposal: action.payload
        });
    }

    @Action(SetIntelligentProposalFlow2)
    setIntelligentProposalFlow2(ctx: StateContext<IntelligentProposalStateModel>, action: SetIntelligentProposalFlow2) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            intelligentProposalFlow2: action.payload
        });
    }

    @Action(SetNextRankPage)
    setNextRankPage(ctx: StateContext<IntelligentProposalStateModel>, { payload }: SetNextRankPage) {
        ctx.patchState({
            nextRankPage: payload
        });
    }
}